<button class="side-menu-toggle-btn clear-btn"
  [disabled]="disableSideButton()"
  [style.background-image]="'url(' + sideMenuBtnImage + ')'"
  (click)="toggleSideMenu()"
  (touchstart)="highlightButton()"
  (touchend)="unhighlightButton()"
  (mousemove)="highlightButton()"
  (mouseenter)="highlightButton()"
  (mouseleave)="unhighlightButton()"
  >
</button>
<div [hidden]="!isSideMenuOpen">
  <div class="side-menu-container"
    [style.background-image]="'url(' + sideMenuTheme.achievements.background + ')'"
    [hidden]="currentTab !== 1"
    >
    @if (showLeaderboard) {
      <button class="clear-btn leaderboard-unused"
        [style.background-image]="'url(' + sideMenuTheme.leaderboard.closed + ')'"
        (click)="openLeaderboard()"
        >
      </button>
    }
    @if (showAvatarMenu) {
      <button class="clear-btn avatar-unused"
        [style.background-image]="'url(' + sideMenuTheme.avatar.closed + ')'"
        (click)="openAvatarMenu()"
        >
        <img class="current-avatar-tab-image" [src]="usersCurrentAvatar.avatar">
      </button>
    }
    <div class="current-tab" [style.background-image]="'url(' + ((showLevel) ? sideMenuTheme.achievements.levelTab : sideMenuTheme.achievements.noLevelTab) + ')'">
      <p class="weekly-time font-24">{{ weeklyTime }}</p>
      <p class="current-unit-sidebar font-24">{{ currentUnit }}</p>
      <p class="daily-points font-26">{{ dailyPoints | number }}</p>
      <p class="weekly-points font-20">{{ weeklyPoints | number }}</p>
      <p class="total-points font-20">{{ totalPoints | number }}</p>
      <div [hidden]="!showLevel" class="level-progress-container" [style.background-image]="'url(' + sideMenuTheme.achievements.weeklyGoalProgressBar + ')'">
        <div style="height: 100%; width: 91%; margin-left: 7%;">
          <!-- Create an array with empty values with a length that is defined by the number stored in weeklyGoal -->
          @for (level of [].constructor(weeklyGoal); track $index; let i = $index) {
            <div class="level-goal">
              @if (i < weeklyGoalProgress) {
                <div class="level-star" [style.background-image]="'url(' + sideMenuTheme.achievements.weeklyGoalGoldStar + ')'"></div>
              }
              @if (i >= weeklyGoalProgress) {
                <div class="level-star" [style.background-image]="'url(' + sideMenuTheme.achievements.weeklyGoalGrayStar + ')'"></div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="side-menu-container"
    [style.background-image]="'url(' + sideMenuTheme.leaderboard.background + ')'"
    [hidden]="currentTab !== 2">
    <button class="clear-btn achievement-unused"
      [style.background-image]="'url(' + sideMenuTheme.achievements.closed + ')'"
      (click)="openAchievements()">
    </button>
    @if (showAvatarMenu) {
      <button class="clear-btn avatar-unused"
        [style.background-image]="'url(' + sideMenuTheme.avatar.closed + ')'"
        (click)="openAvatarMenu()">
        <img class="current-avatar-tab-image" [src]="usersCurrentAvatar.avatar">
      </button>
    }
    <div class="current-tab" [style.background-image]="'url(' + sideMenuTheme.leaderboard.open + ')'">
      <p class="team-leaderboard-name font-25">{{ usersTeam?.teamName }}</p>
      <p class="team-leaderboard-points font-20">{{ studentsTeamPoints?.dailyPoints | number }}</p>
      @if (isSideMenuOpen) {
        <div class="team-standing-container">
          @for (teamStanding of teamStandingList; track teamStanding) {
            <div
              class="team-standing"
              [style]="teamStanding.background"
              [class]="teamStanding.animation">
              <p [hidden]="hideScore(teamStanding.index)"
              class="team-standing-name font-13">{{ teamStanding.teamName }}</p>
              <p [hidden]="hideScore(teamStanding.index)"
              class="team-standing-points font-15">{{ teamStanding.weeklyPoints | number }}</p>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <div class="side-menu-container"
    [style.background-image]="'url(' + sideMenuTheme.avatar.background + ')'"
    [hidden]="currentTab !== 3">
    <button class="clear-btn achievement-unused"
      [style.background-image]="'url(' + sideMenuTheme.achievements.closed + ')'"
      (click)="openAchievements()">
    </button>
    @if (showLeaderboard) {
      <button class="clear-btn leaderboard-unused"
        [style.background-image]="'url(' + sideMenuTheme.leaderboard.closed + ')'"
        (click)="openLeaderboard()">
      </button>
    }
    <div class="current-tab" [style.background-image]="'url(' + sideMenuTheme.avatar.open + ')'">
      <img class="tab-open-image" [src]="usersCurrentAvatar.avatar">
      <button class="clear-btn select-avatar-btn" (click)="selectAvatar()"></button>
      <!-- Ternary operator on the avatar item path so it doesn't fetch the null asset if it isn't set -->
      <div
        class="avatar-preview"
        [style.background-image]="previewedAvatar?.avatarItem ? 'url(' + previewedAvatar!.avatarItem!.avatar + ')' : ''"
      ></div>
      <div class="avatar-carousel-container">
        <button class="clear-btn"
          [class]="{'back-avatar-btn-disabled': disableScrollLeft, 'back-avatar-btn': !disableScrollLeft}"
          (click)="scrollLeft()"
          [disabled]="disableScrollLeft">
        </button>
        <div class="avatar-carousel">
          @for (item of carouselItemList; track item; let i = $index) {
            @if (item.visible) {
              <button class="clear-btn empty-carousel-item" [class.selected-carousel-item]="item.selected"
                [disabled]="item.disabled"
                (click)="previewAvatar(i)">
                @if (item.avatarItem != null) {
                  <div
                    class="avatar-carousel-item"
                    [style.background-image]="'url(' + item.avatarItem.avatar + ')'"
                    >
                  </div>
                }
              </button>
            }
          }
        </div>
        <button class="clear-btn"
          [class]="{'next-avatar-btn-disabled': disableScrollRight, 'next-avatar-btn': !disableScrollRight}"
          (click)="scrollRight()"
          [disabled]="disableScrollRight">
        </button>
      </div>
    </div>
    <p [hidden]="!isSideMenuOpen" class="school-name font-11">{{ school }}</p>
  </div>
</div>
